const b = {
  host: "",
  basePath: "/api/v1.0",
  authToken: ""
};
function s(r) {
  return {
    get: async (i = {}) => await $(r, "GET", {}, i),
    post: async (i = {}, f = {}) => await $(r, "POST", i, f),
    put: async (i = {}, f = {}) => await $(r, "PUT", i, f),
    patch: async (i = {}, f = {}) => await $(r, "PATCH", i, f),
    head: async (i = {}) => await $(r, "HEAD", {}, i),
    del: async (i = {}, f = {}) => await $(r, "DELETE", i, f)
  };
}
async function $(r, u, e = {}, t = {}) {
  return new Promise(async (n, o) => {
    const c = await fetch(r, {
      method: u,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${b.authToken}`,
        ...t
      },
      body: u === "GET" ? void 0 : JSON.stringify(e)
    }).catch((i) => {
      o(i);
    });
    if (!c)
      return o("No response");
    if (!c.ok)
      return o(c);
    try {
      const i = await c.json();
      n(i);
    } catch {
      n(!0);
    }
  });
}
function T(r, u, e) {
  const t = `${r}${u}/${e}/account`;
  function n() {
    return s(t).get();
  }
  return { get: n };
}
function O(r, u, e) {
  const t = `${r}${u}/${e}`;
  function n() {
    return s(t).get();
  }
  function o(g) {
    return s(t).put(g);
  }
  function c() {
    return s(t).del();
  }
  function i(g) {
    return s(t + "/release").post(g);
  }
  function f() {
    return s(t + "/duplicate").post();
  }
  return { get: n, put: o, del: c, release: i, duplicate: f };
}
function P(r, u) {
  const e = `${r}${u}/domains`;
  function t() {
    return s(e).get();
  }
  function n(o) {
    return s(e).post(o);
  }
  return { get: t, post: n };
}
function w(r, u, e) {
  const t = `${r}${u}/${e}/members`;
  function n() {
    return s(t).get();
  }
  function o(i) {
    return s(t).post(i);
  }
  function c(i) {
    return s(t).del(i);
  }
  return { get: n, post: o, del: c };
}
function D(r, u, e) {
  const t = `${r}${u}/${e}/searchUsers`;
  function n(o) {
    return s(`${t}?query=${o}`).get();
  }
  return { get: n };
}
function j(r, u, e) {
  const t = `${r}${u}/${e}/graph`;
  function n(c) {
    return s(t + "/" + c).get();
  }
  function o(c, i) {
    return s(t).patch({ id: c, knowledgeObject: i });
  }
  return { get: n, patch: o };
}
function N(r, u, e) {
  const t = `${r}${u}/${e}/datatypes`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function A(r, u, e, t) {
  const n = `${r}${u}/${e}/datatype/${t}`;
  function o() {
    return s(n).get();
  }
  function c(g) {
    return s(n).put(g);
  }
  function i() {
    return s(n).del();
  }
  function f() {
    return s(`${n}/duplicate`).post({ id: t });
  }
  return { get: o, put: c, del: i, duplicate: f };
}
function L(r, u, e) {
  const t = `${r}${u}/${e}/enumItems`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function F(r, u, e, t) {
  const n = `${r}${u}/${e}/enumItem/${t}`;
  function o() {
    return s(n).get();
  }
  function c(f) {
    return s(n).put(f);
  }
  function i() {
    return s(n).del();
  }
  return { get: o, put: c, del: i };
}
function J(r, u, e, t) {
  const n = `${r}${u}/${e}/infmodel/view/${t}`;
  function o() {
    return s(n).get();
  }
  function c(f) {
    return s(n).put(f);
  }
  function i() {
    return s(n).del();
  }
  return { get: o, put: c, del: i };
}
function U(r, u, e) {
  const t = `${r}${u}/${e}/infmodel/views`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function G(r, u, e) {
  const t = `${r}${u}/${e}/dataobjects`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function C(r, u, e, t) {
  const n = `${r}${u}/${e}/dataobject/${t}`;
  function o() {
    return s(n).get();
  }
  function c(f) {
    return s(n).put(f);
  }
  function i() {
    return s(n).del();
  }
  return { get: o, put: c, del: i };
}
function W(r, u, e) {
  const t = `${r}${u}/${e}/attributes`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function H(r, u, e, t) {
  const n = `${r}${u}/${e}/attribute/${t}`;
  function o() {
    return s(n).get();
  }
  function c(f) {
    return s(n).put(f);
  }
  function i() {
    return s(n).del();
  }
  return { get: o, put: c, del: i };
}
function V(r, u, e) {
  const t = `${r}${u}/${e}/attributes/order`;
  function n(o) {
    return s(t).patch(o);
  }
  return { patch: n };
}
function x(r, u, e) {
  const t = `${r}${u}/${e}/fragments`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function R(r, u, e, t) {
  const n = `${r}${u}/${e}/fragment/${t}`;
  function o() {
    return s(n).get();
  }
  function c(f) {
    return s(n).put(f);
  }
  function i() {
    return s(n).del();
  }
  return { get: o, put: c, del: i };
}
function q(r, u, e) {
  const t = `${r}${u}/${e}/functions`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function z(r, u, e, t) {
  const n = `${r}${u}/${e}/function/${t}`;
  function o() {
    return s(n).get();
  }
  function c(f) {
    return s(n).put(f);
  }
  function i() {
    return s(n).del();
  }
  return { get: o, put: c, del: i };
}
function B(r, u, e) {
  const t = `${r}${u}/${e}/emitters`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function M(r, u, e, t) {
  const n = `${r}${u}/${e}/emitter/${t}`;
  function o() {
    return s(n).get();
  }
  function c(f) {
    return s(n).put(f);
  }
  function i() {
    return s(n).del();
  }
  return { get: o, put: c, del: i };
}
function K(r, u, e) {
  const t = `${r}${u}/${e}/events`;
  function n() {
    return s(t).get();
  }
  function o(c) {
    return s(t).post(c);
  }
  return { get: n, post: o };
}
function Q(r, u, e, t) {
  const n = `${r}${u}/${e}/event/${t}`;
  function o() {
    return s(n).get();
  }
  function c(f) {
    return s(n).put(f);
  }
  function i() {
    return s(n).del();
  }
  return { get: o, put: c, del: i };
}
function X(r, u) {
  const e = `${r}${u}/gpt`;
  function t(n) {
    return s(e).post(n);
  }
  return { post: t };
}
function y(r, u, e) {
  m(r, () => {
    r.send(
      JSON.stringify({
        type: "send",
        topic: u,
        payload: e
      })
    );
  });
}
function l(r, u) {
  m(r, () => {
    r.send(
      JSON.stringify({
        type: "subscribe",
        topic: u
      })
    );
  });
}
function h(r, u) {
  m(r, () => {
    r.send(
      JSON.stringify({
        type: "unsubscribe",
        topic: u
      })
    );
  });
}
function m(r, u) {
  if (r.readyState != WebSocket.OPEN) {
    const e = () => {
      r.removeEventListener("open", e), u();
    };
    r.addEventListener("open", e);
  } else
    u();
}
function Y(r, u, e) {
  const t = `/${u}`;
  function n(i) {
    y(r, t, i);
  }
  function o(i) {
    l(r, t), e[t] = i;
  }
  function c() {
    h(r, t), delete e[t];
  }
  return { send: n, on: o, off: c };
}
function Z(r, u, e) {
  const t = `/${u}/graph`;
  function n(c) {
    l(r, t), e[t] = c;
  }
  function o() {
    h(r, t), delete e[t];
  }
  return { on: n, off: o };
}
function _(r, u, e, t) {
  const n = `/${u}/infmodel/${e}`;
  function o(f) {
    y(r, n, f);
  }
  function c(f) {
    l(r, n), t[n] = f;
  }
  function i() {
    h(r, n), delete t[n];
  }
  return { send: o, on: c, off: i };
}
function I(r, u, e, t) {
  const n = `/${u}/${e}/dataobject/live-position`;
  function o(f) {
    y(r, n, f);
  }
  function c(f) {
    l(r, n), t[n] = f;
  }
  function i() {
    h(r, n), delete t[n];
  }
  return { send: o, on: c, off: i };
}
function tt(r, u, e, t) {
  const n = `/${u}/fragment/${e}/node-live-position`;
  function o(f) {
    y(r, n, f);
  }
  function c(f) {
    l(r, n), t[n] = f;
  }
  function i() {
    h(r, n), delete t[n];
  }
  return { send: o, on: c, off: i };
}
let p;
const a = {};
let E;
const S = [];
let d = !1;
function k(r, u) {
  p || (p = new WebSocket(`${r}${u}`)), p.onopen = () => {
    d && (d = !1, S.forEach((e) => e())), setTimeout(() => Object.keys(a).forEach((e) => l(p, e)), 100), E = setInterval(() => {
      p.readyState === WebSocket.OPEN && p.send(JSON.stringify({ type: "keepalive" }));
    }, 1e4);
  }, p.onclose = () => {
    clearInterval(E), d = !0, setTimeout(() => {
      p = new WebSocket(`${r}${u}`), k(r, u);
    }, 1e3);
  }, p.onmessage = (e) => {
    var c;
    const t = JSON.parse(e.data), n = t.topic, o = t.payload;
    (c = a[n]) == null || c.call(a, o);
  };
}
function nt(r, u) {
  return k(r, u), {
    onDisconnect: (e) => {
      p.addEventListener("close", e);
    },
    onReconnect: (e) => {
      S.push(e);
    },
    domain: (e) => ({
      ...Y(p, e, a),
      graph: () => Z(p, e, a),
      infmodel: () => ({
        view: (t) => ({
          ..._(p, e, t, a),
          livePosition: () => I(p, e, t, a)
        })
      }),
      expknowledge: () => ({
        fragment: (t) => ({
          livePosition: () => tt(p, e, t, a)
        })
      })
    })
  };
}
let v;
function et(r = {}) {
  if (!v) {
    const t = new URL(b.host || window.location.href), o = `${t.protocol == "http:" ? "ws" : "wss"}://${t.host}`;
    v = nt(o, "/api/v1.0");
  }
  const u = r.host || b.host, e = r.host || b.basePath;
  return {
    socket: () => v,
    domains: () => P(u, e),
    domain: (t) => ({
      ...O(u, e, t),
      account: () => T(u, e, t),
      members: () => w(u, e, t),
      searchUsers: () => D(u, e, t),
      graph: () => j(u, e, t),
      datatypes: () => N(u, e, t),
      datatype: (n) => A(u, e, t, n),
      enumItems: () => L(u, e, t),
      enumItem: (n) => F(u, e, t, n),
      infmodel: () => ({
        views: () => U(u, e, t),
        view: (n) => J(u, e, t, n)
      }),
      dataobjects: () => G(u, e, t),
      dataobject: (n) => C(u, e, t, n),
      attributes: () => ({
        ...W(u, e, t),
        order: () => V(u, e, t)
      }),
      attribute: (n) => H(u, e, t, n),
      fragments: () => x(u, e, t),
      fragment: (n) => ({
        ...R(u, e, t, n)
      }),
      functions: () => q(u, e, t),
      function: (n) => z(u, e, t, n),
      emitters: () => B(u, e, t),
      emitter: (n) => M(u, e, t, n),
      events: () => K(u, e, t),
      event: (n) => Q(u, e, t, n)
    }),
    gpt: () => X(u, e)
  };
}
export {
  et as api,
  b as apiConfig
};
